var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentViewIcon = function SvgCurrentViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21V21C20.1046 21 21 20.1046 21 19",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19V5",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H14",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V3C3.89543 3 3 3.89543 3 5V5",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5V9.062",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H19",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3V3C20.1046 3 21 3.89543 21 5",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H3.5V21C3.22386 21 3 20.7761 3 20.5V20.094V20.094C3.00329 18.9389 3.93887 18.0033 5.09399 18H8.406V18C9.56112 18.0033 10.4967 18.9389 10.5 20.094V20.5C10.5 20.7761 10.2761 21 10 21V21V21Z",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 15.5V15.5C5.64541 15.5 4.74999 14.6046 4.75 13.5C4.75001 12.3954 5.64545 11.5 6.75002 11.5C7.85146 11.5 8.74558 12.3906 8.74999 13.492V13.492C8.7544 14.5966 7.86256 15.4956 6.758 15.5C6.75533 15.5 6.75266 15.5 6.74998 15.5L6.74998 15.5Z",
    stroke: "#F2F2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCurrentViewIcon as ReactComponent };
export default __webpack_public_path__ + "current-view-icon.svg";